export const PH_TEMPLATE = '<ph id="{0}">|B&gt;</ph>';
export const BPT_TEMPLATE = '<bpt id="{0}">|B&gt;</bpt>';
export const EPT_TEMPLATE = '<ept id="{0}">&lt;E|</ept>';

export const HTML_TAG_TEMPLATE =
  "<img class='{0}' alt={1} src='data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=='/>";

export const SEARCHED_PHRASE_HTML = '<span class="search-found">{0}</span>';

export function BPT(id) {
  return GenerateHtmlVersionOfTag("bpt", id);
}
export function EPT(id) {
  return GenerateHtmlVersionOfTag("ept", id);
}
export function PH(id) {
  return GenerateHtmlVersionOfTag("ph", id);
}
export function XlifBPT(id) {
  return BPT_TEMPLATE.replace("{0}", id);
}
export function XlifEPT(id) {
  return EPT_TEMPLATE.replace("{0}", id);
}
export function XlifPH(id) {
  return PH_TEMPLATE.replace("{0}", id);
}

export function ConvertTagsToHtml(segment) {
    
  //It could've been done by Regex expression, but this piece of code
  //will be called often and it have to be performed in a split secound
  //so performance is pretty important and, unfortunately, regex is not known
  //from it's efficiency

  //0. init
  let tagFound = false;
  let tags = [Tag];

  //1. Creating copy, so the function parameter won't be affected
  let sample = segment.substring(0);
  let result = "";
  let plainText = "";

  do{
  
      let foundTag = findTag(sample);
      tagFound = foundTag !== null;    

      //3. If tag has been found, then it has to be replaced with html
      if(tagFound){

          tags.push(foundTag);
          //3.1 Form the tag
          let tag = TagToHtml(foundTag);

          //3.2 Form new sample
          let start = sample.substring(0, foundTag.Start);
          let end = sample.substr(foundTag.End + 1);

          result = result + start + tag;
          sample = end;
          plainText += start;
      }
      else{
          result += sample;
          plainText += sample;
      }
  }
  while(tagFound);

  return {
      ResultHTML: result,
      Tags: tags,
      PlainText: plainText
  };
}

export function ConvertHtmlToTags(segment) {
  return segment.replace(/<img[^>]*>/g, (x) => {
      let classString = x.match(/class=[',"]([^',"]*)[',"]/)[1];
      let c = classString.split(' ')[0];
      let alt = x.match(/alt=[',"]([^',"]*)[',"]/)[1];
      let template = "";
      switch(c)
      {
          case "bpt": template = BPT_TEMPLATE; break;
          case "ept": template = EPT_TEMPLATE; break;
          case "ph": template = PH_TEMPLATE; break;
      }
      return template.replace("{0}", alt);
  });
}
export function FindHtmlTags(segment) {
  let match = segment.match(/<img[^>]*>/g);
  if(match === null) return [];
  return match.map(x=> {
      let classString = x.match(/class=[',"]([^',"]*)[',"]/)[1];
      let c = classString.split(' ')[0];
      let alt = x.match(/alt=[',"]([^',"]*)[',"]/)[1];

      let tag = {
          Type: c, //as "bpt" | "ept" | "ph",
          Value: alt
      };

      return tag;
  });
}

/**
* This method makes sure, that there is no <span class='search-found'> tags in.
* @param segment 
*/
export function StripAwaySearchFoundTags(segment) {
  return segment.replace(/<span class=[',"]search-found[',"]>([^<]*)<\/span>/g, (x) => x.match(/>([^<]*)</)[1]);
}

export function ConvertHTMLToTagsAndMarkSearchedPhrase(segment, searchedPhrase){
  
  let phraseHtml = SEARCHED_PHRASE_HTML.replace("{0}", searchedPhrase);

  return segment.replace(RegExp(searchedPhrase, "g"), phraseHtml);
}


export function FindTagToInject(segmentTags) {

  var selection = window.getSelection();
  if(selection === null){
      return null;
  }
  if(selection.anchorNode === null){
      return null;
  }
  
  if(segmentTags === null){
      return null;
  }
  if(segmentTags.length === 0){
      return null;
  }

  let anchorNode = selection.anchorNode; //: Node | null
  while(anchorNode !== null){

      let className = (anchorNode).className;

      if(className !== null && className !== undefined && typeof(className) === "string"){

          let cc = className.split(' ');
          if(cc.some(x=> x === "target")){
              break;
          }
      }

      
      anchorNode = anchorNode.parentNode;
  }

  let lastTagBeforeCaret = null;
  let firstTagAfterCaret = null;


  //- Inject unique text where is caret
  if(selection.rangeCount === 0) return null;
  let range = selection.getRangeAt(0);
  let textNode = document.createTextNode("?!|");
  range.insertNode(textNode);
  
  //- Use it to divide html to two pieces: html before caret and html after caret
  if(anchorNode === null ){ textNode.remove(); return null;}
  let htmls = (anchorNode).innerHTML.split("?!|");
  let before = htmls[0];
  let after = htmls[1];

  //- Delete unique text
  textNode.remove();

  //1. Find last tag before caret
  let beforeTags = FindHtmlTags(before);
  if(beforeTags.length > 0){
      lastTagBeforeCaret = beforeTags[beforeTags.length - 1];
  }

  //2. Find first tag after caret
  let afterTags = FindHtmlTags(after);
  if(afterTags.length > 0){
      firstTagAfterCaret = afterTags[0];
  }

  //3. Find tag that belongs between those two tags

  let l = lastTagBeforeCaret !== null ? segmentTags.findIndex(x=>x.Type === lastTagBeforeCaret.Type && x.Value === lastTagBeforeCaret.Value) : 0;
  let r = firstTagAfterCaret !== null ? segmentTags.findIndex(x=>x.Type === firstTagAfterCaret.Type && x.Value === firstTagAfterCaret.Value) : segmentTags.length;

  if(l + 1 < r) {
    console.log("SEEGMENT TAGGGGGGG",segmentTags[l + 1])
    return segmentTags[l + 1];
  }
  
  else return null;
}

/**
* IMPORTANT! - this function will find only first tag in the segment 
* @param sample 
*/
function findTag(sample) {

  let tagFound = false;
  let tagType = "";
  let id = "";
  let tagStart = 0;
  let tagEnd = 0;
  
  //2. Main loop, in the search of '<' tag
  //   (-15 is because it is the smallest possible amount of chars
  //    required to write the smallest tag (without first '<' char)) 
  //    <ph id="1"></ph> )
  for(let i = 0; i < sample.length - 15; i++){

      if(sample[i] === '<'){

          //2.1 beggining char was found. Now code has to check wether it 
          //begins the tag or is it just random element
          let firstLetter = sample[i + 1];
          let secoundLetter = sample[i + 2];
          let thirdLetter = sample[i + 3];

          tagStart = i;
          tagEnd = i;

          if(firstLetter === 'p' && secoundLetter === 'h' && thirdLetter === ' '){
              //this is a ph tag
              tagType = "ph";
          }
          else{
              if(secoundLetter === 'p' && thirdLetter === 't'){
                  //?pt, so if first letter is 'b' or 'e' and fourth is ' ',
                  //then it is either bpt or ept tag
                  if(sample[i + 4] === ' '){
                      //fourth letter is ' ', so all that's left is checking
                      //first letter
                      if(firstLetter === 'b'){
                          //it's bpt tag
                          tagType = "bpt";
                      }
                      else if(firstLetter === 'e'){
                          tagType = "ept";
                      }
                      else continue;
                  }
                  else continue;
              }
              else continue;
          }
          //2.2 Algorithm has confirmation, that there is a tag and
          //it knows it's type. Now there is a search for 'id'
          i = i + 3;
          for(;i < sample.length; i++){
              
              if(sample[i] === 'i'){
                  
                  //2.2.1 In the tag, there is a letter 'i' found.
                  //Algorithm checks is it [whitespace]id="?????" attribute
                  if(sample[i - 1] === ' ' && sample[i + 1] === 'd' && sample[i + 2] === '=' && sample[i + 3] === '"'){
                      
                      //2.2.2 'id' attribute identified. Extract it's value
                      let start = i + 4;
                      let end = start + 1;
                      
                      i = i + 5;
                      //2.2.2.1 Search for closing '"' of id attribute
                      for(; i < sample.length; i++){
                          if(sample[i] !== '"'){
                              end++;
                          }
                          else break;
                      }
                      //2.2.2.2 closing attribute was found. Value of id
                      //between start and end indexes
                      id = sample.substring(start,end);
                      break;
                  }
                  else continue;
              }
              else continue;
          }

          //2.3 Algorithm found value of id. Now it looks for end </[type]>
          //    (-5 is because </ph>)
          for(;i < sample.length - 4; i++){
              if(sample[i] === '<'){
                  if(sample[i + 1] === '/'){
                      let fl = sample[i + 2];
                      if(fl === 'p' && tagType === "ph"){
                          if(sample[i + 3] === 'h' && sample[i + 4] === '>'){
                              tagEnd = i + 4;
                              tagFound = true;
                              break;
                          }
                          else continue;
                      }
                      else if(sample[i + 3] === 'p' && sample[i + 4] === 't' && sample[i + 5] === '>'){
                          if((fl === 'b' && tagType === "bpt") || (fl === 'e' && tagType === "ept")){
                              tagEnd = i + 5;
                              tagFound = true;
                              break;
                          }
                          else continue;
                      }
                  }
              }
          }

          if(tagFound){
              break;
          }
      }
      else continue;
  }


  return tagFound ? {
      Type: tagType,
      Value: id,
      Start: tagStart,
      End: tagEnd
  } : null;
}

export function GenerateHtmlVersionOfTag(tag, id){
  return `<img class='${tag} ${tag}${id}' alt='${id}' src='data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=='/>`;
}

/**
* This method converts object of Tag interface into html string representing it
* @param tag 
*/
export function TagToHtml(foundTag) {
  
  let tag = "";
  switch(foundTag.Type){
      case "bpt":
          tag = GenerateHtmlVersionOfTag("bpt", foundTag.Value);
          break;
      case "ept":
          tag = GenerateHtmlVersionOfTag("ept", foundTag.Value);
          break;
      case "ph":
          tag = GenerateHtmlVersionOfTag("ph", foundTag.Value);
          break;
  }
  return tag;
}
export function TagToXlif(tag) {
  let template = "";

  switch(tag.Type){
      case "bpt": template = BPT_TEMPLATE; break;
      case "ept": template = EPT_TEMPLATE; break;
      case "ph": template = PH_TEMPLATE; break;
      case "search-found": template = "{0}"; break;
      default: throw new Error("Unknown tag type: '" + tag.Type + "'");
  }

  //this space at the end is required to make cursor appear after the tag
  return template.replace("{0}", tag.Value);    
}

export function replaceAll(text, toReplace, replacingValue) {
  return text.split(toReplace).join(replacingValue);
}

export const decodeEntities = (function() {
    // this prevents any overhead from creating the object each time
    var element = document.createElement('div');
  
    function decodeHTMLEntities (str) {
      if(str && typeof str === 'string') {
        // strip script/html tags
        str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gmi, '');
        str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gmi, '');
        element.innerHTML = str;
        str = element.textContent;
        element.textContent = '';
      }
  
      return str;
    }
  
    return decodeHTMLEntities;
  })();


export const Tag = {
  Type: "bpt" | "ept" | "ph" | "not-found",
  Value: String,
  Start: Number,
  End: Number,
}

export const HtmlTag = {
  Type: "bpt" | "ept" | "ph" | "search-found",
  Value: String,
}


export const TagConvertionResult = {
  ResultHTML: String,
  Tags: [{Tag}],
  PlainText: String,
}
